<template>
    <div>
        <div class="col-12 mb10 selectCol">
            <select class="input" :name="names.country" :id="names.country" v-model="currentCountry" @change="updateAddress">
                <option v-for="(country, iso) in countries" :key="country" :value="iso" :selected="currentCountry == iso">{{ country }}</option>
            </select>
        </div>

        <div class="col-12 flex mb10">
            <input class="input mr10" style="width: 40%" :name="names.postal" v-model="currentPostal" autocomplete="off"
                   :placeholder="`${ label('shop.account.address.postal') } (*)`" @keyup="updateAddress"
                   :id="names.postal"/>
            <input class="input mr10" style="width: 30%" :name="names.house_number" v-model="currentHouseNumber" :id="names.house_number" autocomplete="off"
                   :placeholder="`${ label('shop.account.address.number') } (*)`" type="tel" @keyup="updateAddress"/>
            <input class="input" style="width: 30%" :name="names.house_number_addition" v-model="currentHouseNumberAddition" :id="names.house_number_addition" autocomplete="off"
                   :placeholder="`${ label('shop.account.address.number_addition') }`"/>
        </div>

        <div class="col-12" v-if="!found">
            <div class="col-12 mb10 redColor" v-if="!skipPostalCheckCountries.includes(currentCountry)">
                Postcode niet gevonden, vul een geldige postcode in
            </div>
            <div class="col-12 mb10">
                <input class="input" :name="names.street" v-model="currentStreet" :id="names.street"
                       :placeholder="`${ label('shop.account.address.street') } (*)`"/>
            </div>

            <div class="col-12 mb10">
                <input class="input" :name="names.city" v-model="currentCity" :id="names.city"
                       :placeholder="`${ label('shop.account.address.city') } (*)`"/>
            </div>
        </div>
        <div v-else class="inline-flex flexColumn">
            <span v-if="currentStreet && currentStreet != ' '" class="mb10 ml5">{{currentStreet}} {{currentHouseNumber}}{{seperator}}{{currentHouseNumberAddition}}, {{ currentCity }}</span>
            <input type="hidden" :name="names.street" :value="currentStreet"/>
            <input type="hidden" :name="names.house_number" :value="currentHouseNumber"/>
            <input type="hidden" :name="names.house_number_addition" :value="currentHouseNumberAddition"/>
            <input type="hidden" :name="names.city" :value="currentCity"/>
            <input type="hidden" :name="names.country" :value="currentCountry"/>
        </div>
    </div>
</template>

<script>
import translations from "../mixins/translations";
import {debounce} from 'lodash';
import {EventBus} from "../../events";

const CancelToken = require('axios').CancelToken;
let cancelSource;

export default {
    name: "AddressAutoComplete",
    mixins: [translations,],
    props: {
        postal: {
            required: false,
            type: String,
            default: '',
        },
        houseNumber: {
            required: false,
            type: String,
            default: '',
        },
        houseNumberAddition: {
            required: false,
            type: String,
            default: '',
        },
        street: {
            required: false,
            type: String,
            default: '',
        },
        city: {
            required: false,
            type: String,
            default: '',
        },
        country: {
            required: false,
            type: String,
        },
        countries: {
            required: true,
            type: Object
        },
        names: {
            required: false,
            type: Object,
            default() {
                return {
                    postal: 'postal',
                    house_number: 'house_number',
                    house_number_addition: 'house_number_addition',
                    street: 'street',
                    city: 'city',
                    country: 'country'
                }
            }
        }
    },
    data() {
        return {
            found: true,
            currentPostal: '',
            currentHouseNumber: '',
            currentHouseNumberAddition: '',
            currentStreet: '',
            currentCity: '',
            currentCountry: '',
            seperator: '',
            skipPostalCheckCountries: ['BE'],
        }
    },
    methods: {
        updateAddress: debounce(function () {
            cancelSource && cancelSource.cancel('Request cancelled');
            cancelSource = CancelToken.source();

            if(this.skipPostalCheckCountries.includes(this.currentCountry)) {
                this.found = false;

                return;
            }

            if (this.currentPostal.length <= 5) return;

            axios.post(`/api/site/lookup-address/`, {
                postal: this.currentPostal,
                house_number: this.currentHouseNumber
            }, {
                cancelToken: cancelSource.token
            })
                .then(response => {
                    let data = response.data;
                    this.currentStreet = data.street;
                    this.currentCity = data.city;
                    this.found = !!data.found;
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        // We cancelled this request...
                    } else {
                      this.found = false;
                        // handle error
                    }
                }).finally(() => {
                this.isLoading = false;
            });
        }, 300),


    },
    mounted() {
        this.currentPostal = this.postal;
        this.currentHouseNumber = this.houseNumber;
        this.currentHouseNumberAddition = this.houseNumberAddition;
        this.currentStreet = this.street.trim();
        this.currentCity = this.city;
        this.currentCountry = this.country;
        if(this.skipPostalCheckCountries.includes(this.currentCountry)) {
            this.found = false;
        }
    },
    watch: {
        currentHouseNumber(newValue){
            if(newValue == ""){
                this.seperator = '';
                this.currentHouseNumberAddition = "";
            }
        },
        currentHouseNumberAddition(){
            this.seperator = '';
            if(this.currentHouseNumber == ""){
                this.currentHouseNumberAddition = "";
            }

            if(this.currentHouseNumberAddition !== ""){
                this.seperator = '-';
            }
        },
        currentCountry(newValue){
            EventBus.$emit('updatedCountry', newValue);
        }
    }
}
</script>

<style scoped>

</style>
